import { useEffect, useRef } from 'react';

/**
* Custom hook that returns a reference to the fullscreen wrapper element.
* Uses useRef and useEffect to get and update the reference only when needed.
**/

const useFullscreenWrapper = () => {
  const fullscreenWrapperRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    // Get the element when mounting the component
    fullscreenWrapperRef.current = document.getElementById("fullscreen-wrapper");

    // The function that will be called before each render to update the reference
    const updateRef = () => {
      fullscreenWrapperRef.current = document.getElementById("fullscreen-wrapper");
    };

    // Add an event listener for fullscreenchange
    // This will fire when the user enters or exits fullscreen mode
    document.addEventListener('fullscreenchange', updateRef);

    // Cleanup: remove the event listener when the component is dismantled
    return () => {
      document.removeEventListener('fullscreenchange', updateRef);
    };
  }, []);

  return fullscreenWrapperRef;
};

export default useFullscreenWrapper;